var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm._.radio,attrs:{"src":_vm.value
      ? require('./images/单选框_选中.svg')
      : require('./images/单选框_未选中.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }